import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-[#0f214a] py-10 sm:py-16 px-4 border-t border-white/5 relative overflow-hidden" data-id="element-49">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8 relative z-10" data-id="element-50">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8" data-id="element-51">
          <img src="https://cdn.magicpatterns.com/uploads/tMLFtU1am6GfqRRN2u2JHQ/1758182731791.jpg" alt="LangeBjergGård Consulting" className="h-8 w-auto object-contain mix-blend-screen opacity-70 hover:opacity-90 transition-opacity" data-id="element-52" />
          <span className="hidden md:block w-px h-4 bg-white/10" data-id="element-53" />
          <span className="text-white/30 text-[11px] font-medium tracking-widest uppercase" data-id="element-54">
            {t.footer.copyright}
          </span>
        </div>

        <div className="flex space-x-8 text-[11px] font-medium text-white/30 tracking-widest uppercase" data-id="element-55">
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-56">
            {t.footer.imprint}
          </span>
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-57">
            {t.footer.privacy}
          </span>
        </div>
      </div>
    </footer>;
}